import { render, staticRenderFns } from "./IndividualDiscussPage.vue?vue&type=template&id=00f67747&scoped=true"
import script from "./IndividualDiscussPage.vue?vue&type=script&lang=js"
export * from "./IndividualDiscussPage.vue?vue&type=script&lang=js"
import style0 from "./IndividualDiscussPage.vue?vue&type=style&index=0&id=00f67747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f67747",
  null
  
)

export default component.exports